import { Injectable, Pipe, PipeTransform } from '@angular/core';

const SourceLabels = {
  linkedin: 'LinkedIn',
  dribbble: 'Dribbble',
  behance: 'Behance',
  github: 'GitHub',
  twitter: 'Twitter',
  facebook: 'Facebook',
  angellist: 'AngelList',
  stackoverflow: 'StackOverflow',
  stackexchange: 'StackExchange',
  xing: 'Xing',
};

@Pipe({
  name: 'rtSourceName',
})
@Injectable({ providedIn: 'root' })
export class SourceNamePipe implements PipeTransform {
  public transform(value: keyof typeof SourceLabels | string): string | undefined {
    return (<Record<string, string>>SourceLabels)[value];
  }
}
